import {useMutation, useQueryClient} from '@tanstack/react-query';
import {fundraiserDocumentsApi} from '../api';
import {useNotifications} from '../../../shared';

export const useDeleteFundraiserDocument = (appealId: string) => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const deleteDocumentMutation = useMutation({
    mutationFn: ({documentId}: {documentId: string}) => fundraiserDocumentsApi.deleteDocument(appealId, documentId),
    onSuccess: () => {
      createNotification({
        title: 'Документ успешно удален',
        name: 'deleteDocument',
        theme: 'success',
      });
      queryClient.invalidateQueries({
        queryKey: ['fundraiser-documents', 'infinite', appealId],
        refetchType: 'all',
      });
    },
  });

  return {
    deleteDocumentMutation,
  };
};
